import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import 'tabler-react/dist/Tabler.css';
import { Error404Page } from 'tabler-react';

import ProtocolMapPage from './pages/ProtocolMapPage';
import PortalMapPage from './pages/PortalMapPage';
import PortalMapProjectPage from './pages/PortalMapProjectPage';
import PortalSelfMapProjectPage from './pages/PortalSelfMapProjectPage';

import { auth } from './services/firebase';

const PrivateRoute = ({component: Component, ...rest}) => {

  const [user, setUser] = useState(null);

  useEffect(() => {
    auth().onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(result => setUser(result.claims));
      } else {
        setUser({disabled: true});
      }
    });    
  }, []);

  return user ? (
    <Route
      {...rest}
      render={props =>
        user.disabled ? <Redirect to={{ pathname: "/signin", state: { from: props.location } }} />
        : <Component {...props} />
      }
    />
  ) : null;
}

function Signout() {
  const [loggedOut, setLoggedOut] = useState(false);

  useEffect(() => {
    auth().signOut().then(() => {
      setLoggedOut(true);
    });
  }, []);

  return loggedOut ? (
    <Redirect to={{ pathname: "/signin" }} />
  ) : null
}

function App() {

  return (
    <BrowserRouter basename="corretor">
      <Switch>
        <Route exact path="/map" component={ProtocolMapPage} />
        <Route exact path="/portal-map" component={PortalMapPage} />
        <Route exact path="/portal-map-project" component={PortalMapProjectPage} />
        <Route exact path="/portal-self-map-project" component={PortalSelfMapProjectPage} />

        <Route path="*" component={Error404Page} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
